import { Reducer } from 'redux';
import { ServiceOrdersState, ServiceOrdersTypes } from './types';

const INITIAL_STATE: ServiceOrdersState = {
  config: undefined,
  pagination: undefined,
  data: [],
  loading: false,
};

const reducer: Reducer<ServiceOrdersState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ServiceOrdersTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ServiceOrdersTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        errorData: undefined,
        ...action.payload,
      };
    case ServiceOrdersTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
